export { default as theme } from './BusinessDashboard';
